// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4761":"5ffa4cfbb3bc390c","6123":"5ffa4cfbb3bc390c"}[chunkId] + ".css";
};